import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import './Drawer.css';

export function Drawer({ open, onClose, title, children, width = 400, className = '' }) {
  const handleEsc = useCallback((e) => {
    if (e.key === 'Escape') onClose?.();
  }, [onClose]);

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [open, handleEsc]);

  if (!open) return null;

  return createPortal(
    <div className="ui-drawer-overlay" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <aside className={`ui-drawer ${className}`} style={{ '--drawer-width': `${width}px` }}>
        {title && (
          <div className="ui-drawer__header">
            <h3 className="ui-drawer__title">{title}</h3>
            <button className="ui-drawer__close" onClick={onClose} aria-label="Закрыть">
              <X size={18} />
            </button>
          </div>
        )}
        <div className="ui-drawer__body">{children}</div>
      </aside>
    </div>,
    document.body
  );
}
